import {
  NOTIFICAION_BANNER_NAMESPACE_KEY,
  StoreShape,
} from 'hellospa/redux/namespaces';

export const getBannerMessages = (state: StoreShape) =>
  state[NOTIFICAION_BANNER_NAMESPACE_KEY];
